export default {
  tableLoading: (state) => state.tableLoading,
  pdfPreviewLoading: (state) => state.pdfPreviewLoading,
  pdf: (state) => state.pdf,
}
